import { memo, ReactNode } from 'react';
import classes from 'classnames';
import Spacer from '../Spacer/Spacer';
import styles from './FieldGroup.module.scss';
import Text from '../Typography/Text';

export interface FieldGroupProps {
  children?: ReactNode;
  direction?: 'horizontal' | 'vertical';
  labelText?: string;
  helperText?: string;
  validationText?: string;
  className?: string;
  labelTextClassName?: string;
  validationTextClassName?: string;
  helperTextClassName?: string;
  dataTestHelperText?: string;
  dataTestValidationText?: string;
}

export default memo(function FieldGroup({
  children,
  direction = 'vertical',
  labelText,
  helperText,
  validationText,
  className,
  labelTextClassName,
  validationTextClassName,
  helperTextClassName,
  dataTestHelperText,
  dataTestValidationText,
}: FieldGroupProps) {
  return (
    <div className={styles['fieldgroup-wrapper']} data-test="fieldgroupWrapper">
      {labelText && (
        <div>
          <Spacer marginVertical="5px">
            <Text
              className={classes(styles['label-text'], labelTextClassName)}
              text={labelText}
              weight="medium"
              level={2}
              dataTest="fieldgroupWrapper-text"
            />
          </Spacer>
        </div>
      )}

      <div
        className={classes(
          styles['fieldgroup-container'],
          direction === 'vertical' && styles.column,
          direction === 'horizontal' && styles.row,
          className,
        )}
      >
        {children}
      </div>

      {helperText && (
        <Text
          kind="p"
          level={3}
          weight="regular"
          className={classes(styles['helper-text'], helperTextClassName)}
          text={helperText}
          dataTest={dataTestHelperText}
        />
      )}

      {validationText && (
        <Text
          kind="p"
          level={3}
          className={classes(
            styles['validation-text'],
            validationTextClassName,
          )}
          dangerouslySetInnerHTML={{ __html: validationText }}
          dataTest={dataTestValidationText}
        />
      )}
    </div>
  );
});
